import React from "react";
import { BarChart } from "@mui/x-charts";

export default function SaitBarChart(props) {
	return (
		<BarChart width={props.width || 500} height={props.height || 300} slotProps={props.slotProps || null} axisHighlight={props.axisHighlight || null} series={props.series} xAxis={props.xAxis} />
	);
}
